// import React from 'react'

// const ViewTracking = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default ViewTracking
//imports
import React, { useState, useEffect } from "react";
import {
  Box,
  Link,
  Breadcrumbs,
  Stack,
  Button,
  Grid,
  AppBar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,TextField,Autocomplete,
  Paper,
  Toolbar,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,Step,StepContent,Stepper,StepLabel,
  DialogActions,
  FormControl,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import { externaldeleteApi, externalgetApi, externalpostApi } from "../../services/external/externalApis";
import { ORDER_API_04, ORDER_API_08, ORDERTRACKING_API_1, SETTINGS_API_04 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import { CON_STATUS_ACTIVE, CON_STATUS_DELETED, CON_STATUS_PENDING } from "../../utils/sys/Constants";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import currencyFormat from "../../utils/common/CurrencyFormat";
function ViewTracking() {
  //hooks
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  const { ORDERCODE } = location.state || {};
  const [orderData, setOrderData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState("");
    const [data, setData] = useState([]); const [data2, setData2] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // New state for snackbar severity
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE,USERNAME } = SYS_USER.USER_PARAM || {};
  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    fetchOrderData();
  }, [ORDERCODE]);

  const fetchOrderData = async () => {
    setIsLoading(true);
    try {
      const orderResult = await externalgetApi(ORDER_API_04, "get", { ORDERCODE });
      console.log("API response:", orderResult);

      const filteredData = Object.values(orderResult)
        .flat()
        .filter((item) => item && item.MENUNAME);

      setOrderData(filteredData);
    } catch (err) {
      console.error("Error fetching order data:", err);
      setError("Failed to load order data");
    } finally {
      setIsLoading(false);
    }
  };
//delete api

  const handleDeleteConfirmation = () => {
    setOpenDialog(true);
  };

  const handleDelete = async () => {
    try {
      await externaldeleteApi(ORDER_API_08, "DELETE", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        ORDERCODE:ORDERCODE,
        STS:CON_STATUS_DELETED,
        ENUSER: USERNAME,
      });

      setSnackbarMessage("Order Canceled successfully!");
      setSnackbarSeverity("success"); // Set severity to success
      setOpenSnackbar(true);
      setOrderData([]); // Clear order data on successful delete
      setTimeout(() => {
        navigate("/orderlist");
      }, 2000); 
    } catch (error) {
      console.error("Failed to delete order:", error);
      setSnackbarMessage("Failed to delete the order.");
      setSnackbarSeverity("error"); // Set severity to error
      setOpenSnackbar(true);
    } finally {
      setOpenDialog(false); // Close the dialog after delete attempt
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setError(null);
  };

  const gotToView = () => {
    navigate("/Trackingorder");
  };

    useEffect(() => {
      const fetchData = async () => {
        try {
          const result = await externalgetApi(SETTINGS_API_04, "get", {
            COMPCODE,
            LOCCODE,
            RESTCODE,
            STS: CON_STATUS_ACTIVE,
          });
         
          setData(result);
          setFilteredData(result);
          setIsLoading(false);
        } catch (err) {
          console.error("Error fetching data:", err);
          setIsLoading(false);
        }
      };
  
      fetchData();
    }, []);

    useEffect(() => {
     
      fetchDataorder();
    }, []);

    const fetchDataorder = async () => {
      try {
        const result = await externalgetApi(ORDERTRACKING_API_1, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
          ORDERCODE:ORDERCODE,
        });
       
        setData2(result);
        setFilteredData(result);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setIsLoading(false);
      }
    };

    const [activeStep, setActiveStep] = React.useState(0);

    const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
  
    const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
  
    const handleReset = () => {
      setActiveStep(0);
    };

    const steps = data2.map((item) => ({
      label: item.ORDERSTATUS,
      description: `Send SMS: ${item.SENDSMS}, Order Code: ${item.ORDERDETCODE}`,
    }));

    const handleConfirm = () => {
      if (!selectedStatus) {
        setErrors({ ORDERSTATUS: "Order status is required" });
        return;
      }
  
      const payload = {
        ORDERCODE:String(ORDERCODE), // Replace with actual order code
        orderstscode: String(selectedStatus.ORDERSTSCODE), // Pass selected order status code
        sts: "A", // Replace with appropriate status
        enuser: "fo@marriott.com", // Replace with current user
      };
      try {
        console.log("Payload for API call:", payload);
        const responseData = externalpostApi(ORDERTRACKING_API_1, payload);
        console.log("Success:", responseData);
        setOpenSnackbar(true);
        fetchDataorder();
        setSelectedStatus(null);
       
      } catch (error) {
        console.error("Error:", error);
      }
  
      console.log("Payload:", payload);
  
      // Replace with your API call logic
     // onConfirm(payload);
    };
  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover" href="/">
                  Home
                </Link>
                <Link underline="hover">Settings</Link>
                <Link underline="hover">Ordercancel</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                 
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AddStyledBox}>
        <Toolbar
          sx={{
            maxWidth: "100%",
            pl: { sm: 2,md:2 },
            pr: { xs: 1, sm: 1 },
            background: theme.palette.background.paper,
            marginTop: { xs: "170px", md: "155px" },
          }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={{
              color: theme.palette.text.primary,
              flex: "1 1 100%",
              ml: 1,
            }}
          >
            Order Number: {ORDERCODE}
          </Typography>
         
        </Toolbar>
        <Grid container spacing={2} p={2} >
      {/* First Table */}
      <Grid container spacing={2} ml={1}>
  {/* First Table: Available Location */}
  <Grid item xs={12} md={6} >
  <Toolbar
      sx={{
        width: "100%",
        background: theme.palette.background.paper,
        marginTop: {
          xs: "170px",
          md: "30px",
        },
        ml:"12",
        p:"2",
        borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
      }}
    >
      <Typography
        sx={{
          color: theme.palette.mode === "dark" ? "#FFFFFF" : "#181818", // styleName: Heading 5;

          fontSize: "20px",
          fontWeight: 600,
        }}
      >
  Tracking Info
      </Typography>
    </Toolbar>
    <Box p={1} sx={styles.st_page_table}>

    <Box sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "50vh", // Full viewport height
   
    margin: "0 auto", // Center horizontally within the viewport
  }}>
   <Stepper activeStep={activeStep} orientation="vertical">
    {steps.map((step, index) => (
      <Step key={step.label} active={true}>
        <StepLabel
          StepIconComponent={() =>  <CheckCircleIcon
            sx={{
              color: theme.palette.primary.main,
            }}
          />}
         
        >
          {step.label}
        </StepLabel>
      </Step>
    ))}
  </Stepper>

    
    </Box>
    </Box>
  </Grid>

  {/* Second Table: Mapped Location */}
  <Grid item xs={12} md={6}>
  <Toolbar
      sx={{
        width: "100%",
        background: theme.palette.background.paper,
        marginTop: {
          xs: "170px",
          md: "30px",
        },
     
        borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
      }}
    >
      <Typography
        sx={{
          color: theme.palette.mode === "dark" ? "#FFFFFF" : "#181818", // styleName: Heading 5;

          fontSize: "20px",
          fontWeight: 600,
        }}
      >
   Next order level 
      </Typography>
   
    </Toolbar>
    <Box p={1} sx={styles.st_page_table}>
    <Box sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "50vh", // Full viewport height
   
    margin: "0 auto", // Center horizontally within the viewport
  }}>
     <Grid container spacing={2} p={1}>
                  <Grid item xs={12} sm={12} md={6}>
                    <Typography variant="h6" align="left">
                    Next level 
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <Stack
                      direction="row"
                      justifyContent="flex-end"
                      spacing={2}
                    >
 {/* <SearchAppBar value={searchText} onChange={handleSearchChange} /> */}
 <FormControl fullWidth size="small">
          <Autocomplete
            options={data || []}
            getOptionLabel={(option) => option.ORDERSTATUS || ""}
            value={selectedStatus}
            onChange={(event, newValue) => {
              setSelectedStatus(newValue);
              setErrors((prev) => ({ ...prev, ORDERSTATUS: "" })); // Clear errors
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  <span>
                    Order Status<span style={{ color: "red" }}> *</span>
                  </span>
                }
                size="small"
                fullWidth
                variant="outlined"
                error={Boolean(errors.ORDERSTATUS)}
                helperText={errors.ORDERSTATUS}
              />
            )}
            ListboxProps={{
              style: {
                maxHeight: 150,
                backgroundColor: theme.palette.background.paper,
              },
            }}
          />
        </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2} justifyContent="flex-end" p={2}>
            <Button
              variant="contained"
              sx={{
                background: theme.palette.primary.main,
                color: theme.palette.text.buttontxt,
                textTransform: "capitalize",
                width: "120px",
              }}
             onClick={handleConfirm}
            >
             Confirm
            </Button>
          </Stack>
                  </Grid>
                </Grid>
     <Grid item lg={6} md={6} xs={12} sm={12}>
   </Grid></Box>
    </Box>
  </Grid>
</Grid>
</Grid>
      
      </Box>

      {error && (
        <Snackbar open={!!error} autoHideDuration={6000} onClose={handleCloseSnackbar}   anchorOrigin={{ vertical: "top", horizontal: "right" }}>
          <Alert severity="error" onClose={handleCloseSnackbar}>
            {error}
          </Alert>
        </Snackbar>
      )}

      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}   anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert severity={snackbarSeverity} onClose={handleCloseSnackbar}>
        {"Sucessfully updated"}
        </Alert>
      </Snackbar>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Cancellation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to Cancel this order?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}  sx={{
                background: theme.palette.primary.main,
                color: theme.palette.text.buttontxt,
              textTransform: "capitalize",
              borderRadius: 2,
              width:"100px",
              px: 3,
              "&:hover": {
                background: theme.palette.primary.main,
              },
            }}color="primary">
           No
          </Button>
          <Button onClick={handleDelete}  sx={{
              backgroundColor:  theme.palette.system.danger,
              color: theme.palette.background.paper,
              textTransform: "capitalize",
              borderRadius: 2,
              width:"100px",
              px: 3,
              "&:hover": {
                backgroundColor:  theme.palette.system.danger,
              },
            }} color="secondary">
         Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ViewTracking;
